import generateCellEditorRendererWithCellType from './generateCellEditorRendererWithCellType';

/**
 * @description
 * Cell editor generator
 * @param {object} gridParam
 * Parameter that contains the grid object(API).
 * @param {string} cellType
 * Grid cell type.
 * @returns
 * Cell editor component
 */
const generateCellEditor = ({
  gridParam,
  cellType,
  adornment,
  regex,
  ...props
}) => {
  const editorCellSettings = {
    component: generateCellEditorRendererWithCellType({
      cellType,
    }),
    params: {
      maxLength: props?.maxLength || 20,
      option: props?.option || [],
      cellType,
      adornment,
      regex,
      ...props,
    },
  };
  return editorCellSettings;
};

export default generateCellEditor;
